import { getCookieItem } from "./cookie";
import cookie from "cookiejs";

export function checkAuthenticated() {
  let isAuthenticated = false;
  const now = new Date()
  const admin = getCookieItem('eden_admin')

  function setIsAuthenticated(status: boolean) {
    isAuthenticated = status
  }

  if (admin) {
    if (now.getTime() > admin.expiry) {
      cookie.remove('eden_admin') //token expired
      return isAuthenticated;
    } else {
      setIsAuthenticated(true)  //token valid
      return isAuthenticated; 
    }
  }

  return isAuthenticated;
}